module.exports = __webpack_public_path__ + "media/icons/switch-member-50806c35.svg";